'use es6';
/*
Since this is a no-auth application, we can't use gates to control access
to new features. This file stores static access control configuration.
*/

export const ACCESS_CONTROL = {
  SCOPE_SPLIT: true
};